import { render } from "./formulas.vue?vue&type=template&id=5b4f25b0"
import script from "./formulas.vue?vue&type=script&lang=js"
export * from "./formulas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__